import { getImageFullUrl } from '@/utils/imageUtils';
import { useTranslation } from 'react-i18next';
import { IonImg, IonIcon, IonThumbnail } from '@ionic/react';
import { IonRouterLink } from '@ionic/react';
import { chatbubbleOutline } from 'ionicons/icons';
import { GolfAvatar } from '../ui/GolfAvatar';

type PostCommentNotificationProps = {
  commentData: {
    postId: number;
    imageUrl?: string;
    text: string;
  };
  senderInfo: {
    name: string;
    username: string;
    avatar: string;
  }[];
};

export function PostCommentNotification({ commentData, senderInfo }: PostCommentNotificationProps) {
  const { t } = useTranslation();
  const otherCommentersCount = senderInfo.length - 1;
  const commentMessage = otherCommentersCount > 0
    ? t('and_others_commented_on_your_post', { count: otherCommentersCount })
    : t('commented_on_your_post');

  return (
    <div className="flex w-full space-x-3 py-4">
      {/* Notification icon on the left */}
      <div className="flex-shrink-0 mt-1">
        <div className="flex items-center justify-center size-8 rounded-full bg-primary/10">
          <IonIcon icon={chatbubbleOutline} className="size-4 text-primary" />
        </div>
      </div>

      {/* Main content */}
      <div className="flex-1">
        <div className="flex items-start justify-between">
          {/* Sender info and text */}
          <div className="flex flex-col">
            <IonRouterLink href={`/u/${senderInfo[0]?.username}`}>
              <GolfAvatar
                imageUrl={senderInfo[0]?.avatar}
                size={32}
              />
            </IonRouterLink>

            <p className="text-sm">
              <IonRouterLink href={`/u/${senderInfo[0]?.username}`} className="mr-1 font-semibold hover:underline text-sm">
                {senderInfo[0]?.name}
              </IonRouterLink>
              {commentMessage}
              <span className="block text-sm text-muted-foreground mt-1">
                {commentData.text}
              </span>
            </p>
          </div>

          {/* Image */}
          {commentData.imageUrl && (
            <IonRouterLink href={`/p/${commentData.postId}`}>
              <img
                src={getImageFullUrl(commentData.imageUrl)}
                alt="Post image"
                className="size-14 rounded-md bg-muted object-cover"
              />
            </IonRouterLink>
          )}
        </div>
      </div>
    </div>
  );
}
